import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaArtistasColaboradores from './TablaArtistasColaboradores';

const ArtistasColaboradores: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaArtistasColaboradores />
    </Box>
  );
};

export default ArtistasColaboradores;
